// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"8":"editor","419":"wiki","467":"download","603":"sponsor","623":"tree","671":"verbose"}[chunkId] || chunkId) + "." + {"8":"864232b6","73":"3766fef3","419":"85d7ac55","467":"c54dbfa2","603":"b1fb54ac","623":"6ca5c380","671":"a5bc0b58"}[chunkId] + ".css";
};